<template>
  <CModal
      :centered="true"
      :show.sync="addExamModal"
      size="md"
      title="ایجاد"
  >
    <CForm class="add-exam-modal text-right">
      <div class="d-flex">
        <CSelect
            v-if="online"
            :options="typeList"
            :value.sync="form.type"
            class="text-sm flex-fill ml-1"
            label="نوع آزمون"
        />
      </div>
      <div class="t-mt-3">درس</div>
      <div v-if="online" class="checkboxes">
        <CInputCheckbox
            v-for="course in courseList"
            :key="course.id"
            :label="`${course.name} ${course.klass.grade.name} ${course.klass.name}`"
            :value="course.id"
            class="text-sm flex-fill pt-2"
            custom
            @update:checked="addCourseIds(course.id, $event)"
        />
      </div>
      <div v-else class="checkboxes">

        <div v-for="course in courseList" :key="course.id">
          <CInputRadio

              :label="`${course.name} ${course.klass.grade.name} ${course.klass.name}`"
              :value="course.id"
              class="text-sm flex-fill"
              custom
              name="course"
              @update:checked="form.courseIds = course.id"
          />
        </div>
      </div>
      <CInput v-model="form.title" class="text-sm mt-3" label="عنوان"/>
      <div class="text-sm mt-2">تاریخ</div>
      <div class="d-flex text-sm mt-2">
        <date-picker
            v-model="form.startDate"
            auto-submit
            class="mt-2 ml-1 flex-fill"
            color="#fbad18"
            format="jYYYY-jMM-jDD"
        />
        <date-picker
            v-if="online"
            v-model="form.startTime"
            :jumpMinute="5"
            :roundMinute="true"
            class="mt-2 flex-fill mx-1"
            color="#fbad18"
            type="time"
        />

        <date-picker
            v-if="online"
            v-model="form.endTime"
            :initial-value="initialEndTime"
            :jumpMinute="5"
            :min="initialEndTime"
            :roundMinute="true"
            class="mt-2 flex-fill mr-1"
            color="#fbad18"
            type="time"
        />
      </div>
      <CInput
          v-if="!online"
          v-model="form.totalMark"
          class="text-sm flex-fill mr-1 mt-3"
          label="بارم"
          type="number"
      />
      <div
          v-if="form.type === 'MULTI_CHOICES' && online"
          class="mt-3 d-flex align-items-center text-sm"
      >
        <CSwitch
            :value="form.randomizeQuestion"
            class="ml-3"
            color="primary"
            variant="3d"
            @update:checked="onRandomizeQuestion"
        />
        نمایش ترتیب سوالات به صورت تصادفی
      </div>
      <div class="mt-3">
        <CTextarea v-model="form.notes[0]" class="text-sm" label="نکات مهم:"/>
        <!-- <h6 class="my-3">نکات مهم آزمون:</h6>-->
        <!--        <CInput-->
        <!--          v-for="(note, index) in form.notes"-->
        <!--          :key="index"-->
        <!--          v-model="form.notes[index]"-->
        <!--          class="text-sm"-->
        <!--          @update:value="removeEmptyNote(index)"-->
        <!--        />-->
        <!--        <CInput v-model="note" class="text-sm" />-->
        <!--        <CButton color="primary" class="px-sm-5 py-sm-2" @click="onAddnotes">-->
        <!--          <CIcon name="cil-plus" />-->
        <!--          افزودن-->
        <!--        </CButton>-->
      </div>
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          class="px-5"
          color="primary"
          @click="onAddExam"
      >
        ثبت
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {datePicker: VuePersianDatetimePicker},

  props: {
    value: {
      type: Boolean,
    },
    online: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        courseIds: [],
        notes: [],
        randomizeQuestion: false,
        totalMark: 100
      },
      loading: false,
      // note: "",
      courseList: [],

      typeList: [
        {
          value: "",
          label: "",
        },
        {
          value: "TEXT",
          label: "تشریحی",
        },
        {
          value: "MULTI_CHOICES",
          label: "چندگزینه ای",
        },
      ],
    };
  },
  computed: {
    addExamModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    initialEndTime() {
      return this.timeFromMins(
          this.timeToMins(this.form.startTime ? this.form.startTime : "00:00") +
          this.timeToMins("00:10")
      );
    },
  },
  watch: {
    addExamModal(val) {
      if (val) {
        this.getCourses();
      }
    },
  },
  methods: {
    async onAddExam() {
      try {
        this.loading = true;
        const payload = {
          courseIds: this.online ? this.form.courseIds : [this.form.courseIds],
          title: this.form.title,
          online: this.online,
          type: this.form.type,
          notes: this.form.notes,
          startDate: this.form.startDate,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          randomizeQuestion: this.form.randomizeQuestion,
          totalMark: this.form.totalMark,
        };
        await axios.post("/exam", payload).then((response) => {
          if (response.data.status)
            this.courseList = []
          this.form = {
            courseIds: [],
            notes: [],
            randomizeQuestion: false,
          };
          this.addExamModal = false;
          this.$emit("get-exams");
        });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    // onAddnotes() {
    //   if (this.note !== "") this.form.notes.push(this.note);
    //   this.note = "";
    // },
    // removeEmptyNote(index) {
    //   if (this.form.notes[index] === "") this.form.notes.splice(index, 1);
    // },
    async getCourses() {
      try {
        this.loading = true;
        const {data} = await axios.get("/course");
        this.courseList = data;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    addCourseIds(item, event) {
      if (event === true) this.form.courseIds.push(item);
      const index = this.form.courseIds.findIndex((val) => val === item);
      if (event === false) this.form.courseIds.splice(index, 1);
    },
    onRandomizeQuestion() {
      this.form.randomizeQuestion = !this.form.randomizeQuestion;
    },
    // Convert a time in hh:mm format to minutes
    timeToMins(time) {
      var b = time.split(":");
      return b[0] * 60 + +b[1];
    },
    // Convert minutes to a time in format hh:mm
    // Returned value is in range 00  to 24 hrs
    timeFromMins(mins) {
      function z(n) {
        return (n < 10 ? "0" : "") + n;
      }

      var h = ((mins / 60) | 0) % 24;
      var m = mins % 60;
      return z(h) + ":" + z(m);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .vpd-container {
    .vpd-content {
      border-radius: 8px;

      .vpd-header {
        border-radius: 8px 8px 0 0;
      }
    }
  }
}

.checkboxes {
  column-count: 2;
  column-gap: 10px;
}
</style>